import { Checkbox } from "@material-ui/core";

import styles from "../createGame.module.css";
import { translate } from "../../../../translations/index.ts";

export default function PartiesStep({ template, setTemplate, parties }) {
  const toggleAllParties = () => {
    const newList =
      template.parties.length > 0 ? [] : parties.map((p) => p._id);
    setTemplate({ ...template, parties: newList });
  };

  const selectParty = (party) => {
    let newList = [...template.parties];
    if (newList.includes(party._id)) {
      newList = newList.filter((id) => id !== party._id);
    } else {
      newList.push(party._id);
    }
    setTemplate({ ...template, parties: newList });
  };

  return (
    <>
      <h3 className={styles.stepTitle}>
        {translate("teacher.gameSettings.steps.parties.label")}
      </h3>
      <div className={styles.allStatementsContainer}>
        <Checkbox
          id="parties-toggle-all"
          checked={template.parties.length === parties.length}
          onChange={toggleAllParties}
        />
        <label htmlFor="parties-toggle-all">
          {translate("teacher.gameSettings.steps.parties.all")}
        </label>
      </div>
      <div className={styles.optionsContainer}>
        {parties.map((party) => (
          <div className={styles.optionContainer} key={party._id}>
            <Checkbox
              value={party._id}
              id={`party-${party._id}`}
              checked={template.parties.includes(party._id)}
              onChange={() => selectParty(party)}
            />
            <label htmlFor={`party-${party._id}`}>{party.name}</label>
          </div>
        ))}
      </div>
    </>
  );
}
